import * as React from "react";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { Helmet } from "react-helmet-async";
import { IMapOptions } from "../interfaces/mapoptions";
import { PoiSearch } from "../api/poisearch";

interface MetaDataPoiProps {
    poiData: PoiSearch;
}

const MetaDataPoi = ({ poiData }: MetaDataPoiProps) => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);
    const imageurl = poiData.result.imageUrl.replace("ms.jpg", "l.jpg");

    const pagetitle = poiData.result.name + " - " + mapoptions.title;

    const metadescription = poiData.result.name +
        " is near the halfway location between " +
        mapoptions.address1 +
        " and " +
        mapoptions.address2 + ".";

    return (<Helmet>
        <title>{pagetitle}</title>
        <meta property="og:title" content={pagetitle} />
        <meta name='description' content={metadescription} />
        <meta property="og:description" content={metadescription} />
        <meta property="og:image" content={imageurl} />
   </Helmet>);
};

export default MetaDataPoi;
